import React, { useState } from 'react';
import { Tabs, Button, Space, Typography, Alert, Tooltip } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import RoleManagement from './RoleManagement';
import PermissionMatrix from './PermissionMatrix';
import DataAssignments from './DataAssignments';
import SpecialPermissions from './SpecialPermissions';
import UserPermissionOverview from './UserPermissionOverview';
import ResourceActionManager from './ResourceActionManager';
import SensitiveFieldsPage from './SensitiveFieldsPage';

const { Title } = Typography;
const { TabPane } = Tabs;

const PermissionManagement: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('roles');
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  // 右上角仅保留刷新，移除未实现的导出/新增按钮

  return (
    <div className="permission-management">
      <div className="page-header" style={{ marginBottom: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Title level={2} style={{ margin: 0 }}>
            {t('menu.permissionManagement')}
          </Title>
          <Space>
            <Tooltip title="全局刷新：重建所有子页面并触发各自数据重新加载">
              <Button 
                icon={<ReloadOutlined />} 
                onClick={handleRefresh}
              >
                全局刷新
              </Button>
            </Tooltip>
          </Space>
        </div>
        <Alert
          type="info"
          showIcon
          style={{ marginTop: 12 }}
          message="快速指引：只做“角色 × 资源 × 操作”的基础控制如何配置？"
          description={
            <div>
              <div>1) 打开“资源与动作”：为各模块准备动作，并确保“资源-动作映射”允许你需要的范围（可只用全局）。</div>
              <div>2) 打开“角色管理”：在权限配置表格中为各角色勾选资源-操作并选择范围（如全局）。保存后“应用到权限矩阵”。</div>
              <div>3) 打开“权限矩阵”：用于查看当前生效结果。若仅做基础控制，可忽略“数据分配/特殊权限/用户概览”。</div>
            </div>
          }
        />
      </div>

      <Tabs 
        activeKey={activeTab} 
        onChange={(k) => { setActiveTab(k); if (k === 'roles') setRefreshKey(prev => prev + 1); }}
        type="card"
        size="large"
      >
        <TabPane tab="资源与动作" key="res-actions">
          <ResourceActionManager key={`res-actions-${refreshKey}`} />
        </TabPane>
        <TabPane tab={t('menu.roleManagement')} key="roles">
          <RoleManagement key={`roles-${refreshKey}`} />
        </TabPane>
        <TabPane tab={t('menu.permissionMatrix')} key="matrix">
          <PermissionMatrix key={`matrix-${refreshKey}`} />
        </TabPane>
        <TabPane tab={t('menu.dataAssignments')} key="assignments">
          <DataAssignments key={`assignments-${refreshKey}`} />
        </TabPane>
        <TabPane tab="敏感字段" key="sensitive-fields">
          <SensitiveFieldsPage key={`sensitive-fields-${refreshKey}`} />
        </TabPane>
        <TabPane tab={t('menu.specialPermissions')} key="special">
          <SpecialPermissions key={`special-${refreshKey}`} />
        </TabPane>
        <TabPane tab={t('menu.userOverview')} key="overview">
          <UserPermissionOverview key={`overview-${refreshKey}`} />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default PermissionManagement;
